module.exports = __webpack_public_path__ + "img/news_28-04-2021-30thAnniversary.18813d15.jpg";